import React, { createContext, useContext } from "react";

interface DemoContextValue {
  isDemo: boolean;
  resetDemo: () => void;
}

const DemoContext = createContext<DemoContextValue>({
  isDemo: false,
  resetDemo: () => {},
});

export function DemoProvider({ isDemo = false, resetDemo = () => {}, children }: {
  isDemo?: boolean;
  resetDemo?: () => void;
  children: React.ReactNode;
}) {
  return (
    <DemoContext.Provider value={{ isDemo, resetDemo }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo(): DemoContextValue {
  return useContext(DemoContext);
}
